import { FC } from 'react';
import {
  Container,
  ContentBox,
  ErrorText
} from '../../styles/chime-react/CommonStyles';
import Heading from '../chat/Heading';
import { BottomButtonWrap } from '../../pages/login';
import PrimaryButton from '../chat/Button/PrimaryButton';
import { useForm } from 'react-hook-form';
import { DefaultPasswordInput } from '../common/elements/PasswordInput';
import { commonPasswordError } from '../../constants';
import { useDebouncedCallback } from 'use-debounce';

type NewPasswordForm = { password: string };

const PasswordSetChallenge: FC<{
  name?: string;
  signIn: (password: string) => void;
  errorMessage?: string;
}> = ({ name, signIn, errorMessage }) => {
  const form = useForm<NewPasswordForm>({ defaultValues: { password: '' } });
  const { handleSubmit } = form;
  const onSubmit = ({ password }: NewPasswordForm) => signIn(password);
  const onSubmitDebounced = useDebouncedCallback(onSubmit, 3_000, {
    leading: true,
    trailing: false
  });

  return (
    <Container maxWidth="606px">
      <Heading level={4} tag="h1" alignCenter={true} mb="2.5rem">
        初期設定（パスワード設定）
      </Heading>
      <form onSubmit={handleSubmit((args) => onSubmitDebounced(args))}>
        <ContentBox>
          {!!name && <p style={{ marginBottom: '1rem' }}>{name}さん</p>}
          <div style={{ marginBottom: '1.5rem' }}>
            新しいパスワードを設定してください。
            <br />
            {commonPasswordError}
          </div>
          <DefaultPasswordInput form={form} />
        </ContentBox>
        <BottomButtonWrap>
          {!!errorMessage && (
            <ErrorText className="error-text">{errorMessage}</ErrorText>
          )}
          <PrimaryButton label="パスワード変更" />
        </BottomButtonWrap>
      </form>
    </Container>
  );
};

export default PasswordSetChallenge;
